import { render, staticRenderFns } from "./NewYears_foodItem.vue?vue&type=template&id=16263b26&scoped=true"
import script from "./NewYears_foodItem.vue?vue&type=script&lang=ts"
export * from "./NewYears_foodItem.vue?vue&type=script&lang=ts"
import style0 from "./NewYears_foodItem.vue?vue&type=style&index=0&id=16263b26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16263b26",
  null
  
)

export default component.exports